module.exports = __webpack_public_path__ + "media/Video (19).ebdc1b8e.mp4";